import Handlebars from "handlebars";
import "#legacy/handlebars_helpers/device_media_helper.js";
import "#legacy/handlebars_helpers/variant_url_helper.js";

Handlebars.registerHelper("responsiveImage", function (image, options, lazy) {
  if (!image) {
    return "";
  }

  var picture, klass, srcName, srcsetName;
  var alt = "";
  var srcName = "src";
  var srcsetName = "srcset";
  var dataLazy = "";

  if (typeof options === "string") {
    klass = options;
  } else {
    klass = "";
  }

  if (lazy) {
    srcName = "data-src";
    srcsetName = "data-srcset";
    dataLazy = 'data-lazy="true"';
  }

  // Avoid 'undefined' alt value
  if (image.alt) {
    alt = ' alt="' + image.alt + '"';
  }

  if (image.variants) {
    picture = '<picture data-lazy="true" class="figure-image-element ' + klass + '">';
    var variants = Handlebars.helpers.ascendingDevicePrecedence(image.variants);

    Object.keys(variants).forEach(function (variantName) {
      var url = Handlebars.helpers.variantUrl(image.id, variantName, image.variants[variantName]);
      var media = Handlebars.helpers.deviceMedia(variantName);
      if (url && media) {
        picture += "<source " + srcsetName + '="' + url + '" media="' + media + '">';
      }
    });

    picture += '<img style="max-width: 100%;"' + alt + " " + dataLazy + " " + srcName + '="' + image.url + '" />';
    picture += "</picture>";
  } else {
    picture =
      '<img style="max-width: 100%;" class="' +
      klass +
      '"' +
      alt +
      " " +
      dataLazy +
      " " +
      srcName +
      '="' +
      image.url +
      '" />';
  }

  return new Handlebars.SafeString(picture);
});
